<terra-dialog-header>
  <h1>Edit Account Details</h1>
</terra-dialog-header>

<div class="content-wrapper">
  <terra-loader class="page-loader" *ngIf="false"></terra-loader>
  <mat-dialog-content class="main-content flex flex-column gap-4 edit-account-details-dialog-content">
    <div class="p-3 flex flex-column gap-1 account-description-container">
      <span class="text-base">{{data.nickname}}</span>
      <span class="text-sm">{{data.bankName}}</span>
      <span class="text-sm">{{data.accountNumber | accountNumberToAstrix: 4}}</span>
    </div>
    <form class="flex flex-column gap-4 pb-4 terra-error-style" id="dialogFormEditBank"
      [formGroup]="pageForm" (keydown.enter)="$event.preventDefault()">
      <!-- Account nickname -->
      <div class="flex flex-column gap-1">
        <label for="txtNickname" class="text-input-label">Account nickname</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtNickname" formControlName="nickname" autocomplete="account-name" class="lo_sensitive"
            placeholder="e.g. Downtown Lofts Operating Account" />
          <mat-error *ngIf="pageForm.get('nickname').hasError('required')"> Required</mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-column gap-1">
        <label class="text-input-label flex gap-1 align-items-baseline">Entity type
          <mat-icon class="help-tooltip-icon" fontSet="material-icons-outlined" pTooltip="Choose whether this account belongs to a specific asset/fund or it is a GP Level account."
            tooltipPosition="top"
            tooltipStyleClass="text-center">help_outline</mat-icon>
        </label>
        <terra-radio-buttons [control]="pageForm.get('entityType')"
          [details]="entityTypesButtons"></terra-radio-buttons>
      </div>
      <div class="full-width flex flex-column gap-1">
        <label class="text-input-label">{{selectedEntityType.selectingEntityPlaceholderlabel}}</label>
        <p-dropdown [options]="selectedEntityType.selectingEntitySource | async" optionValue="id" optionLabel="id"
          [formControl]="pageForm.get(selectedEntityType.selectingEntityFormControlName)"
          [placeholder]="getSelectEntityPlaceholder()"
          class="entity-dropdown-container" styleClass="entity-dropdown" #businessTypeSelect>
          <ng-template let-selected pTemplate="selectedItem">
            <span>{{ selectedEntityType.itemLabelBuilder(selected) }}</span>
          </ng-template>
          <ng-template let-entity pTemplate="item">
            <div class="flex justify-content-between">
              <span class="flex flex-wrap align-content-center">{{ selectedEntityType.itemLabelBuilder(entity) }}</span>
              <button *ngIf="selectedEntityType.value === EntityType.GpLevel" mat-icon-button class="edit-icon-button"><mat-icon class="edit-icon"
                  (click)="createEditCompany(entity); $event.stopImmediatePropagation(); $event.preventDefault()"
                  fontSet="material-icons-outlined">edit</mat-icon></button>
            </div>
          </ng-template>
          <ng-template let-entity pTemplate="footer">
            <div class="flex justify-content-center p-2" *ngIf="selectedEntityType.shouldHaveAddFooter">
              <terra-buttons *ngIf="selectedEntityType.value === EntityType.GpLevel" class="button-no-border" type="secondary" label="New Business Entity" icon="add"
                [outlinedIcon]="true" (click)="createEditCompany(null); $event.stopImmediatePropagation(); $event.preventDefault()"></terra-buttons>
            </div>
          </ng-template>
          <ng-template pTemplate="empty">
            <div class="flex flex-column justify-content-center align-items-center gap-2">
              <mat-icon class="h-2rem w-2rem" [svgIcon]="selectedEntityType.value === EntityType.GpLevel ? 'business_entity' : null">
                {{selectedEntityType.value === EntityType.Holding ? 'domain' : null}}
              </mat-icon>
              <span>{{selectedEntityType.emptyStateText}}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <mat-error *ngIf="pageForm.get(selectedEntityType.selectingEntityFormControlName).hasError('required') && pageForm.get(selectedEntityType.selectingEntityFormControlName).touched"> Required</mat-error>
      </div>
      <div class="full-width flex flex-column gap-1">
        <label class="text-input-label">Account type</label>
        <p-dropdown [options]="accountTypeOption"
        [disabled]="!selectedEntityType.haveAccountType"
        [formControl]="pageForm.get('accountType')">
          <ng-template let-selected pTemplate="selectedItem">
            <div class="flex flex-row gap-2">
              <mat-icon [svgIcon]="AccountType.getIcon(selected)"></mat-icon>
              <span class="flex flex-wrap align-content-center">{{ selected | enumString:AccountType }}</span>
            </div>
          </ng-template>
          <ng-template let-entity pTemplate="item">
            <div class="flex flex-row gap-2">
              <mat-icon [svgIcon]="AccountType.getIcon(entity)"></mat-icon>
              <span class="flex flex-wrap align-content-center">{{ entity | enumString:AccountType }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </form>
  </mat-dialog-content>
</div>

<mat-dialog-actions class="flex justify-content-end pt-4 pb-4">
  <!-- Error message -->
  <p *ngIf="pageForm.invalid && isSubmitted" class="error-message">
    Please review and correct the fields marked in red
  </p>
  <p *ngIf="pageForm.valid && (isGeneralServerError$ | async)" #serverError class="error-message">
    <span [innerHTML]="generalServerErrorMessage"></span>
  </p>
  <button [disabled]="false" [mat-dialog-close]="undefined" type="button" mat-button color="primary"
    class="cancel-button tall-button">
    Cancel
  </button>
  <terra-buttons label="Save Changes" (click)="save()"></terra-buttons>
</mat-dialog-actions>
